'use client'

import { useEffect, useState } from 'react'
import { Mail, MailCheck } from 'lucide-react'

/**
 * One-click opt-in to the daily "Morning Brief" email (top play + why, biggest gappers, who reports today,
 * plus your watchlist movers). OPT-IN only — off by default. Renders nothing for logged-out visitors.
 */
export default function DailyBriefToggle({ className = '' }: { className?: string }) {
  const [authed, setAuthed] = useState(false)
  const [available, setAvailable] = useState(false)
  const [on, setOn] = useState(false)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    fetch('/api/email/daily-brief')
      .then((r) => r.json())
      .then((d) => { setAuthed(!!d?.authed); setOn(!!d?.enabled); setAvailable(!!d?.available) })
      .catch(() => {})
  }, [])

  const toggle = async () => {
    setBusy(true)
    const next = !on
    try {
      const r = await fetch('/api/email/daily-brief', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ enabled: next }) })
      if (r.ok) setOn(next)
    } catch { /* leave state unchanged */ }
    setBusy(false)
  }

  if (!authed || !available) return null
  return (
    <button
      onClick={toggle}
      disabled={busy}
      title={on ? 'Daily Morning Brief email is on - click to turn off' : 'Get a daily Morning Brief email: top play, biggest gappers & why, who reports today, and your watchlist movers'}
      className={`inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[12px] font-semibold transition-colors disabled:opacity-60 ${on ? 'border-emerald-500/40 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20' : 'border-zinc-700/60 bg-zinc-900/60 text-zinc-300 hover:border-amber-500/50 hover:text-amber-300'} ${className}`}
    >
      {on ? <MailCheck className="h-3.5 w-3.5" /> : <Mail className="h-3.5 w-3.5" />}
      {busy ? '…' : on ? 'Daily brief on' : 'Daily brief'}
    </button>
  )
}
